import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'helpers/CSSModulesUtil'
import { compose, nest } from 'recompose'
import { connect } from 'react-redux'
import T from 'i18n-react'

import Card from './Card'
import Actions from './Actions'
import Table from './Table'
import TableNavigation from './TableNavigation'
import Divider from 'components/fulcrum/divider/Divider'
import {
  default as Collapse,
  withCollapse
} from 'components/fulcrum/collapse/Collapse'
import CardHeader from 'components/custom/Card/CardHeader'
import Section from 'components/custom/Section/Section'
import {
  withEditHandlers
} from 'components/custom/EditIconButton/index'
import ProgressBarHoc from 'containers/Async/AsyncProgressBarHoc'

import {
  FETCH_PROJECTS,
} from './constants'

import {
  fetchProjects,
  changePageSize,
  updateCurrentPage,
  incrementPage,
  decrementPage,
  changeSearchValue,
  patchProjects,
  changeSelectSite,
  changeEdit,
  clear
} from './actions'

import {
  countSelector,
  pageSizeSelector,
  currentPageSelector,
  sitesSelector,
  selectedSitesSelector,
  enabledSitesSelector,
  isFirstPageSelector,
  isLastPageSelector,
  searchValueSelector,
} from './selectors'

import styles from './styles.scss'

const mapStateToProps = (state) => {
  return {
    pageSize: pageSizeSelector(state),
    count: countSelector(state),
    page: currentPageSelector(state),
    sites: sitesSelector(state),
    selectedSites: selectedSitesSelector(state),
    enabledSites: enabledSitesSelector(state),
    isLastPage: isLastPageSelector(state),
    isFirstPage: isFirstPageSelector(state),
    searchValue: searchValueSelector(state),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchProjects: () => dispatch(fetchProjects()),
    changePageSize: (size) => dispatch(changePageSize(size)),
    incrementPage: () => dispatch(incrementPage()),
    decrementPage: () => dispatch(decrementPage()),
    onSearch: (value) => dispatch(changeSearchValue(value)),
    updateEnable: (value) => dispatch(patchProjects(value)),
    selectSite: (value) => dispatch(changeSelectSite(value)),
    changeEdit: (value) => dispatch(changeEdit(value)),
    clear: () => dispatch(clear())
  }
}

const ProgressBar = ProgressBarHoc(() => <div/>)([FETCH_PROJECTS])

class ApprovalCard extends Component {
  componentDidMount() {
    this.props.fetchProjects()
  }

  componentWillUnmount() {
    this.props.clear()
  }

  onEdit = () => {
    this.props.toggleEdit(!this.props.edit)
    this.props.changeEdit(!this.props.edit)
  }

  render() {
    const {
      collapse,
      toggleCollapse,
      pageSize,
      count,
      page,
      sites,
      changePageSize,
      selectSite,
      incrementPage,
      decrementPage,
      isLastPage,
      isFirstPage,
      onSearch,
      searchValue,
    } = this.props
    return (
      <Card>
        <CardHeader title={T.translate('containers.manage.nvqualSubmissions.approvalCard.title')}>
          <Actions
            collapse={collapse}
            toggleCollapse={toggleCollapse}
            onEdit={this.onEdit}
            onSearch={onSearch}
            searchValue={searchValue}
          />
        </CardHeader>
        <Collapse collapse={collapse}>
          <Table
            source={sites}
            onClick={selectSite}
          />
          <ProgressBar/>
          <TableNavigation
            page={page}
            pageSize={pageSize}
            count={count}
            changePageSize={changePageSize}
            incrementPage={incrementPage}
            decrementPage={decrementPage}
            isLastPage={isLastPage}
            isFirstPage={isFirstPage}
          />
        </Collapse>
      </Card>
    )
  }
}

const withStyle = CSSModules(styles)
const withConnect = connect(mapStateToProps, mapDispatchToProps)
const enhance = compose(
  withConnect,
  withCollapse,
  withEditHandlers,
  withStyle
)
const ApprovalCardEnhance = enhance(ApprovalCard)

export default nest(Section, ApprovalCardEnhance)
